import request from '@/router/axios';

const urlPrefix = process.env.VUE_APP_LOCAL_DEVELOPMENT == 'false' ? '/wage' : '/wage'
//const urlPrefix = "http://192.168.251.61:8888/biz"


export function getCodeItems(codesSetId){
  return request({
    url: urlPrefix+'/bill/notice/codeItemList',
    method: 'get',
    params: {codeSetId: codesSetId}
  })
}
export function getCostCenterList(cusId){
  return request({
    url: urlPrefix+'/salarysetting/get-costcenter-by-cusid',
    method: 'get',
    params: {cusId:cusId}
  })
}
//分页查询
export function getListpage(obj) {
  return request({
    url: urlPrefix + '/bill/notice/list-page',
    method: 'post',
    data: obj,
  });
}
//批量账单确认
export function batchAgentConfirm(obj) {
  return request({
    url: urlPrefix + '/bill/notice/batchAgentConfirm',
    method: 'put',
    data: obj,
  });
}
//批量删除账单
// export function batchDeleteNotice(obj) {
//   return request({
//     url: urlPrefix + '/bill/notice/batchDeleteNotice',
//     method: 'delete',
//     data: obj,
//   });
// }


//创建客户账单
export function createNotice(obj) {
  return request({
    url: urlPrefix + '/bill/notice/createNotice',
    method: 'post',
    data: obj
  });
}
//查询客户账单信息
export function getNoticeInfo(noticeId) {
  return request({
    url: urlPrefix + '/bill/notice/find-noticeinfo',
    method: 'get',
    params: {noticeId:noticeId}
  });
}
//查询客户账单信息
// export function getNoticeInfoByProcess(processId) {
//   return request({
//     url: urlPrefix + '/bill/notice/process-noticeinfo',
//     method: 'get',
//     params: {processId:processId}
//   });
// }
// //创建发票
// export function createInvoice (obj) {
//   return request({
//     url: urlPrefix + '/bill/notice/createInvoice',
//     method: 'post',
//     data: obj,
//   });
// }
// //查询业务票据项明细
// export function getBizItemList (id) {
//   return request({
//     url: urlPrefix + '/bill/notice/detail-biz-item',
//     method: 'post',
//     params:{noticeId:id},
//   });
// }
// //查询雇员台账明细
// export function getEmpItemListPage (obj) {
//   return request({
//     url: urlPrefix + '/bill/notice/detail-emp-item',
//     method: 'post',
//     data: obj,
//   });
// }

//查询雇员台账明细
// export function getEmpWageListPage (obj) {
//   return request({
//     url: urlPrefix + '/bill/notice/detail-emp-wage',
//     method: 'post',
//     data: obj,
//   });
// }
export function saveUseBalance (obj) {
  return request({
    url: urlPrefix + '/bill/notice/save-balance',
    method: 'post',
    data: obj,
  });
}

// return request({
//
//   url: urlPrefix + '/demoperson/del/'+obj,
//   method: 'delete',
//   data: obj,
// });
//批量账单确认
export function updatePayTemplate(obj) {
  return request({
    url: urlPrefix + '/bill/notice',
    method: 'put',
    data: obj,
  });
}
//冲账操作
// export function strikeBalance(obj) {
//   return request({
//     url: urlPrefix + '/bill/notice/applyStrikeBalance',
//     method: 'put',
//     data: obj,
//   });
// }
//发送付款通知单邮件
// export function sendPayNotMail(obj) {
//   return request({
//     url: urlPrefix + '/bill/notice/mail',
//     method: 'get',
//     params: obj,
//   });
// }

